import { render } from "./Gerenciamento.vue?vue&type=template&id=db01e84a&scoped=true"
import script from "./Gerenciamento.vue?vue&type=script&lang=js"
export * from "./Gerenciamento.vue?vue&type=script&lang=js"

import "./Gerenciamento.vue?vue&type=style&index=0&id=db01e84a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db01e84a"]])

export default __exports__